<!-- 弹出层行编辑 - popover -->
<template>
  <el-popover
    popper-class="row-editor"
    placement="top"
    width="300"
    :title="fieldInfo.fieldLabel"
    v-model="visible"
    @show="handlePopupVisible"
    @hide="handlePopupHide"
    :disabled="disabled"
  >
    <div v-if="visible" style="display: flex">
      <el-form ref="rowEditorFormRef" :model="editInfo" :rules="rules">
        <el-form-item :prop="fieldInfo.fieldName">
          <el-input
            v-if="inputType === 'input'"
            v-model="editInfo[fieldInfo.fieldName]"
            :maxlength="maxlength"
          ></el-input>
          <el-select v-else v-model="editInfo[fieldInfo.fieldName]">
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.value"
              :label="item.label"
              >{{ item.label }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 10px">
        <el-button
          type="primary"
          icon="el-icon-check"
          circle
          @click="updateDetail"
        ></el-button>
        <el-button
          icon="el-icon-close"
          circle
          @click="visible = false"
        ></el-button>
      </div>
    </div>
    <div slot="reference">
      <span v-if="disabled"  :style="{
          cursor: 'pointer',
          color: '#1c7ab3',
          ...fieldStyle
        }">{{ transValue || '暂无数据' }}</span>
      <span
      v-else
        :style="{
          cursor: 'pointer',
          color: '#1c7ab3',
          ...fieldStyle
        }"
        >{{ (!transValue && transValue !== 0) ?  "编辑" : transValue }}</span
      >
    </div>
  </el-popover>
</template>

<script>
import { getRequest, postRequest } from "@/api/matrixApi";
import {
  validateTrainType,
  validateTrainNo,
  validateContainerNo,
  validateWeight,
} from "@/util/validate";

export default {
  name: "row-editor",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // 需要修改的字段信息
    fieldInfo: {
      type: Object,
      default() {
        return {
          fieldLabel: "",
          fieldName: "",
        };
      },
    },
    // 输入框类型
    inputType: {
      type: String,
      default: "input",
    },
    // 行信息
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    // 校验规则
    rules: {
      type: Object,
      default() {
        return {
          trainType: [{ validator: validateTrainType, trigger: "blur" }],
          trainNo: [{ validator: validateTrainNo, trigger: "blur" }],
          trainLoad: [{ validator: validateWeight, trigger: "blur" }],
          trainSelf: [{ validator: validateWeight, trigger: "blur" }],
          trainVolume: [{ validator: validateWeight, trigger: "blur" }],
          trainChange: [{ validator: validateWeight, trigger: "blur" }],
          containerNo1: [{ validator: validateContainerNo, trigger: "blur" }],
          containerNo2: [{ validator: validateContainerNo, trigger: "blur" }],
          seaContainerNo: [{ validator: validateContainerNo, trigger: "blur" }],
        };
      },
    },
    // 修改接口地址
    editUrl: {
      type: String,
      default: "/check/train/detailList/update",
    },
    // 接口方法，默认 post (目前只支持 post 和 get)
    requestMethod: {
      type: String,
      default: "post",
    },
    // 下拉选择框选项
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    customParams: {
      type: Object,
      default() {
        return {};
      },
    },
    maxlength: {
      type: [Number, String],
    },
    fieldStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      editInfo: {},
      loading: true,
    };
  },
  computed: {
    transValue() {
      const { fieldName } = this.fieldInfo;
      if (this.inputType === "select") {
        const selected = this.options.find(
          (o) => o.value === this.row[fieldName]
        );
        if (selected) {
          return selected.label;
        }
      }
      return this.row[fieldName];
    },
  },
  methods: {
    handlePopupVisible() {
      const { fieldName } = this.fieldInfo;
      this.editInfo = { [fieldName]: this.row[fieldName] };
    },
    handlePopupHide() {
      const formRef = this.$refs.rowEditorFormRef;
      if (!formRef) return;
      formRef.clearValidate();
    },
    cancelUpdate() {
      this.visible = false;
    },
    // 更新表单
    updateDetail() {
      const { fieldName } = this.fieldInfo;
      // if (this.editInfo[fieldName] === this.row[fieldName]) {
      //   this.visible = false;
      //   return;
      // }
      const formRef = this.$refs.rowEditorFormRef;
      if (!formRef) return;
      formRef.validate((valid) => {
        if (valid) {
          const params = {
            id: this.row.id,
            ...this.editInfo,
            ...this.customParams,
          };
          this.toRequest(params).then((res) => {
            if (res && res.code === 200) {
              this.$message.success("修改成功");
              this.row[fieldName] = this.editInfo[fieldName];
              this.visible = false;
              this.$emit("detailUpdate", this.row,fieldName);
            }
          });
        }
      });
    },
    toRequest(params) {
      this.loading = true;
      return this.requestMethod === "post"
        ? postRequest(this.editUrl, params)
        : getRequest(this.editUrl, params);
    },
  },
};
</script>

<style lang="scss">
.el-popup-parent--hidden {
  .el-select-dropdown
    .el-scrollbar
    .el-scrollbar__view
    .el-select-dropdown__item {
    padding: 0 20px;
  }
}
</style>
